export const ONE_TIME_QUERY = ['focus_event', 'exclusive_condition', 'exclusive_promoter', 'exclusive_feature']
export const EXCLUSIVE_CONDITION_QUERY = 'exclusive_condition'
export const EXCLUSIVE_PROMOTER_QUERY = 'exclusive_promoter'
export const EXCLUSIVE_FEATURE_QUERY = 'exclusive_feature'
export const EXCLUSIVE_QUERY = ['filter[region]', 'filter[area_group]', 'filter[area]', 'filter[prefecture]']
